import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  constructor() { }

  environment:string = environment.name;

  getApiEndpoint():string {
    return environment.apiEndpoint;
  }

  getPutterId():number {
    return environment.putterClubId;
  }

  isProdEnvironment():boolean {
    let env = environment.name;
    return env === 'prod';
  }
}
